<div class="folder-wrapper background-white" (drop)="onDrop($event)">
  <mat-progress-bar *ngIf="isLoading || uploading || isDownloadInProgress || isSearching" mode="indeterminate"
    style="z-index: 100"></mat-progress-bar>
  <div class="top-bar-wrapper">
    <div class="folder-header">
      <div class="left-side">
        <img [src]="localImages.backIcon" (click)="navigateBack()" class="cursor-pointer" alt="" height="24"
          width="24" />

        <div>
          <mat-form-field *ngIf="folderName !== 'null'" style="margin-top: 8px; cursor: auto"
            [hideRequiredMarker]="true">
            <input type="text" class="editable" matInput id="editFolderInput" [(ngModel)]="folderName"
              [readonly]="!isEditing" required (click)="$event.preventDefault(); $event.stopPropagation()"
              [style.width.px]="(folderName.length + 1) * 11.5" (keydown.enter)="editFolderName(); isEditing = false"
              (input)="folderExists = false" (mouseenter)="onInputMouseEnter()" />

            <img src="assets/icons/edit-doc.svg" *ngIf="!isEditing" (click)="startEditing()" style="
                cursor: pointer;
                margin-left: 16px;
                position: relative;
                bottom: 6px;
              " matSuffix />
            <img src="assets/icons/check-doc.svg" (click)="
                $event.preventDefault();
                $event.stopPropagation();
                isEditing = false;
                editFolderName()
              " *ngIf="isEditing" style="
                cursor: pointer;
                margin-left: 16px;
                margin-right: 8px;
                position: relative;
                bottom: 6px;
              " matSuffix />
            <img src="assets/icons/close-doc.svg" (click)="
                $event.preventDefault();
                $event.stopPropagation();
                cancelEditing()
              " *ngIf="isEditing" style="cursor: pointer; position: relative; bottom: 6px" matSuffix />
          </mat-form-field>
        </div>
      </div>
      <div class="right-side">
        <app-invoice-status-label *ngIf="renderStatusComponent() && !isStatusLabelHidden" [hideOnCreated]="true"
          [item]="folder"></app-invoice-status-label>
        
        <button class="secondary-button" (click)="createInvoice()">
          <mat-icon>post_add</mat-icon>
          <span>{{ "createInvoice" | translate }}</span>
        </button>

        <button class="secondary-button" (click)="openYourBooks()">
          <mat-icon>auto_stories</mat-icon>
          <span>{{ "yourBooks" | translate }}</span>
        </button>

        <button *ngIf="
            folderStatus == folderStatuses.SUCCESS && folder.invoicesCount !== 0
          " [class.hide-text]="folderStatuses.FAILED" matBadge="&#8288;" matBadgePosition="before" matBadgeColor="warn"
          matTooltip="You have new changes in the folder, since the last Run"
          [matTooltipDisabled]="folderStatus != folderStatuses.FAILED" mat-icon-button
          [disabled]="folderStatus == folderStatuses.FAILED || uploading"
          [matBadgeHidden]="folderStatus != folderStatuses.FAILED" class="right-side-download-image"
          (click)="openTemplateDialog(folder)">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8043 15.021 15.413 15.413C15.021 15.8043 14.55 16 14 16H2ZM8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12Z"
              fill="#1C1B1F" />
          </svg>
        </button>

        <button mat-icon-button
          (click)="setFolderPassword($event, folder)"
          matTooltip="{{ folder?.isPasswordProtected ? 'Manage folder password' : 'Set folder password' }}"
          style="margin-right: 4px">
          <mat-icon style="color: #1e31cf">{{ folder?.isPasswordProtected ? 'lock' : 'lock_open' }}</mat-icon>
        </button>

        <div class="add-invoice">
          <button class="primary-button with-padding" (click)="createFolder()" style="width: 202px">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 12H14V10H16V8H14V6H12V8H10V10H12V12ZM2 16C1.45 16
                       0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45
                       0.196 0.979333 0.588 0.588C0.979333 0.196 1.45 0 2 0H8L10 2H18C18.55
                       2 19.021 2.196 19.413 2.588C19.8043 2.97933 20 3.45 20 4V14C20 14.55
                       19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H2ZM2
                       2V14H18V4H9.175L7.175 2H2Z" fill="white" />
            </svg>
            &nbsp;
            <span>{{ "createSubFolder" | translate }}</span>
          </button>
        </div>
      </div>

      <div class="action-bar" *ngIf="selectedInvoicesNum > 0">
        <div style="display: flex; align-items: center; margin-left: 16px">
          <mat-icon style="margin-right: 8px; cursor: pointer; font-size: 26px"
            (click)="toggleAllSelection(false)">close</mat-icon>
          <span class="custom-button-selected">{{ selectedInvoicesNum }}
            {{ selectedInvoicesNum == 1 ? "item" : "items" }} selected</span>
        </div>
        <div style="display: flex; align-items: center">
          <button class="custom-button" mat-button (click)="toggleAllSelection(true)">
            Select all
          </button>
          <button class="custom-button" *ngIf="selectedInvoicesNum >= 2" mat-button (click)="toggleAllSelection(false)">
            Unselect all
          </button>
          <button class="custom-button" *ngIf="selectedInvoicesNum === 1" mat-button
            (click)="toggleAllSelection(false)">
            Unselect
          </button>
          <!-- <button class="warn" mat-button (click)="bulkDeleteInvoices()">
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
                fill="#BA1A1A"
              />
            </svg>
          </button> -->
          <div class="icon-wrapper" style="margin-top: 4px; margin-right: 8px"
            (click)="$event.stopPropagation(); bulkDeleteInvoices()" (mouseover)="isHovered = true"
            (mouseleave)="isHovered = false">
            <svg (click)="$event.stopPropagation(); bulkDeleteInvoices()" width="24" height="18" viewBox="0 0 16 18"
              fill="none" xmlns="http://www.w3.org/2000/svg" [style.fill]="isHovered ? '#1E31CF' : '#27272C'">
              <path d="M3 18C2.45 18 1.97933 17.8043 1.588
                                        17.413C1.196
                                        17.021 1 16.55 1
                                        16V3H0V1H5V0H11V1H16V3H15V16C15
                                        16.55
                                        14.8043 17.021 14.413 17.413C14.021 17.8043
                                        13.55
                                        18
                                        13
                                        18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9
                                        14H11V5H9V14Z" />
            </svg>
          </div>

          <div class="icon-wrapper" style="margin-top: 4px; margin-right: 8px"
            (click)="$event.stopPropagation(); openBulkAssignDialog()" (mouseover)="isHovered = true"
            (mouseleave)="isHovered = false">
            <mat-icon>person_add</mat-icon>
          </div>

        </div>
      </div>
    </div>

    <div class="search-field-container">
      <div class="search-wrapper">
        <mat-form-field [hideRequiredMarker]="true" appearance="outline">
          <mat-label>Search Invoices</mat-label>
          <input matInput [(ngModel)]="searchText" (input)="searchInvoices(searchText)" placeholder="Search by name" />
          <mat-icon style="cursor: pointer; margin-top: 5px" *ngIf="searchText" matSuffix
            (click)="searchText = ''; searchInvoices('')">close</mat-icon>
          <mat-icon matSuffix *ngIf="!searchText">search</mat-icon>
        </mat-form-field>
      </div>
      
      <div class="search-actions">
        <mat-menu #menu="matMenu" [overlapTrigger]="false">
          <!-- <button mat-menu-item (click)="runNano(folder)">Nano</button> -->

          <button mat-menu-item 
            (click)="runFolder(folder.id, folder, TF.FALSE)"
            [disabled]="hasFilesRequiringGoodsAndMaterialProcessingInCurrentFolder()"
            [matTooltip]="hasFilesRequiringGoodsAndMaterialProcessingInCurrentFolder() ? 'TXT/XLSX files require Goods and Material processing' : ''"
            [class.disabled-menu-item]="hasFilesRequiringGoodsAndMaterialProcessingInCurrentFolder()">
            Regular
          </button>
          <button mat-menu-item (click)="runFolder(folder.id, folder, TF.TRUE)">
            Goods and Material
          </button>
        </mat-menu>
        <button *ngIf="!isProcessing() && !areWeinRunningProccess" mat-button class="run-button"
          [matMenuTriggerFor]="menu" [disabled]="!isInvoices || isProcessing() || uploading"
          [class.disabled-run-button]="
            !isInvoices || isProcessing() || uploading
          ">
          {{ "run" | translate }}
        </button>
        <button *ngIf="isProcessing() && areWeinRunningProccess" mat-button
          class="run-button red-button" (click)="stopScanning(folder.id, folder)"
          [disabled]="isStopScanningInProccess" [class.disabled-run-button]="isStopScanningInProccess">
          Stop scanning
        </button>

        <!-- <button mat-icon-button [matMenuTriggerFor]="moreMenu" class="more-button">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          
        </mat-menu> -->
      </div>
    </div>

    <!-- Added spacer div to avoid content from being hidden behind the header since search is sticky -->
    <div style="margin-top:160px; display:flex"></div>
    <!-- End of spacer div -->


    <div class="parent-folder-drop-zone"
      [class.visible]="(isDraggingInvoice && folder?.parentFolderID) || isDraggingFolder"
      (dragover)="onParentFolderDragOver($event)" (dragleave)="onParentFolderDragLeave()"
      (drop)="onParentFolderDrop($event)" [class.drop-target]="isParentFolderDropTarget">
      <div class="drop-zone-content">
        <mat-icon>arrow_upward</mat-icon>
        <span>Move to Parent Folder</span>
      </div>
    </div>

    <!-- Subfolders -->
    <ng-container *ngIf="!isLoading && subfolders?.length && !isDownloadInProgress">




      <div class="scrollable-container" #scrollableContainer (scroll)="onScroll($event)" style=" overflow-x: auto;">
        <table class="si-table">
          <thead style="z-index: 1">
            <tr>
              <th>
                <div class="header-content">
                  <button mat-icon-button (click)="toggleSort('name')">
                    <svg class="asc" [class.active]="sort.name == 'asc'" width="10" height="5" viewBox="0 0 10 5"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                    </svg>
                    <svg class="desc" [class.active]="sort.name == 'desc'" width="10" height="5" viewBox="0 0 10 5"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                    </svg>
                  </button>
                  <span class="roboto">Name</span>
                </div>
              </th>
              <th>
                <div class="header-content">
                  <button mat-icon-button (click)="toggleSort('number')">
                    <svg class="asc" [class.active]="sort.number == 'asc'" width="10" height="5" viewBox="0 0 10 5"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                    </svg>
                    <svg class="desc" [class.active]="sort.number == 'desc'" width="10" height="5" viewBox="0 0 10 5"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                    </svg>
                  </button>
                  <span class="roboto">Invoices</span>
                </div>
              </th>
              <th>
                <div class="header-content">
                  <button mat-icon-button (click)="toggleSort('status')">
                    <svg [class.active]="sort.status == 'asc'" class="asc" width="10" height="5" viewBox="0 0 10 5"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                    </svg>
                    <svg [class.active]="sort.status == 'desc'" class="desc" width="10" height="5" viewBox="0 0 10 5"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                    </svg>
                  </button>
                  <span class="roboto">Activity</span>
                </div>
              </th>
              <th>
                <div class="header-content">
                  <button mat-icon-button (click)="toggleSort('latestScanType')">
                    <svg class="asc" [class.active]="sort.latestScanType == 'asc'" width="10" height="5"
                      viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                    </svg>
                    <svg class="desc" [class.active]="sort.latestScanType == 'desc'" width="10" height="5"
                      viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                    </svg>
                  </button>
                  <span class="roboto">Latest Scan Type</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="show-on-hover cursor-pointer" [class.drop-target]="dropTargetFolder?.id === item.id"
              (mouseover)="onMouseOver(i)" (mouseleave)="onMouseLeave(i)" *ngFor="
                let item of filteredSubfoldersList
                  | sort : sort[activeSort] : activeSort : 'string';
                let i = index
              " (click)="openItem(item, $event)" [draggable]="true" (dragstart)="onFolderDragStarted(item, $event)"
              (dragend)="onFolderDragEnded()"
              (dragover)="(isDraggingFolder && draggedFolder?.id !== item.id) || isDraggingInvoice ? onFolderDragOver($event, item) : null"
              (dragleave)="onFolderDragLeave()"
              (drop)="(isDraggingFolder && draggedFolder?.id !== item.id) || isDraggingInvoice ? onFolderDrop($event, item) : null">
              <td style="padding-left: 47px" class="sorted">
                <div class="item-name">
                  <mat-icon *ngIf="item.type === 'folder' && item.isPasswordProtected"
                    style="font-size:16px;width:16px;height:16px;vertical-align:middle;margin-right:4px;color:#1e31cf"
                    matTooltip="Password protected">lock</mat-icon>
                  {{ item.type === 'folder' ? item.name : item.title }}
                </div>
              </td>
              <td class="sorted" style="width: 100px">
                <p>
                  {{ item.type === 'folder' ? (item.invoicesCount || '-') : 1 }}
                </p>
              </td>

              <td class="scan-task-status-sorted">
                <app-invoice-status-label [item]="item"></app-invoice-status-label>
              </td>
              <td class="sorted">
                <div class="latest-scan-type">{{item.type == "folder" ? item.latestScanType : "" }}</div>
              </td>
              <td>
                <div class="operations triggered" [ngStyle]="{
                    opacity: hoveredIndex === i || openDropdownIndex === i ? 1 : 0
                  }" style="
                    display: flex;
                    align-items: center;
                    transition: opacity 0.2s ease;
                  ">
                  <!-- <button
                        *ngIf="!isProcessingSubfolder(getStatus(item))"
                        mat-icon-button
                        [disabled]="isProcessingSubfolder(getStatus(item))"
                        (click)="$event.stopPropagation(); deleteFolder($event, item)"
                        > -->
                  <div class="icon-wrapper" (click)="$event.stopPropagation(); deleteSubFolder($event, item)"
                    (mouseover)="isHovered = true" (mouseleave)="isHovered = false"
                    *ngIf="!isProcessingSubfolder(getStatus(item)) && item.type == 'folder'">
                    <svg (click)="
                        $event.stopPropagation(); deleteSubFolder($event, item)
                      " width="24" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                      [style.fill]="isHovered ? '#1E31CF' : '#27272C'">
                      <path d="M3 18C2.45 18 1.97933 17.8043 1.588
                        17.413C1.196
                        17.021 1 16.55 1
                        16V3H0V1H5V0H11V1H16V3H15V16C15
                        16.55
                        14.8043 17.021 14.413 17.413C14.021 17.8043
                        13.55
                        18
                        13
                        18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9
                        14H11V5H9V14Z" />
                    </svg>
                  </div>
                  <!-- </button> -->
                  <!-- matTooltip="You have new changes in the folder, since the last Run" -->
                  <!-- *ngIf="item.status == folderStatuses.FAILED" -->
                  <button *ngIf="false && item.type == 'folder'" class="hide-text" matBadge="&#8288;"
                    matBadgePosition="before" matBadgeColor="warn" mat-icon-button>
                    <svg width="16" height="16" viewBox="0 0 16
                        16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 16C1.45 16 0.979333 15.8043
                           0.588
                           15.413C0.196 15.021 0 14.55 0
                           14V11H2V14H14V11H16V14C16 14.55 15.8043
                           15.021
                           15.413
                           15.413C15.021 15.8043 14.55 16 14 16H2ZM8
                           12L3
                           7L4.4
                           5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12Z" fill="#CCCCCC" />
                    </svg>
                  </button>
                  <button mat-icon-button *ngIf="
                      item.type == 'folder' && 
                      item.status == folderStatuses.SUCCESS &&
                      item.invoicesCount !== 0
                    " (click)="$event.stopPropagation(); openTemplateDialog(item)" matTooltipClass="custom-tooltip">
                    <svg *ngIf="
                        !item.areThereMissingFields || item.areThereMissingFields
                      " class="success-included-download-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_1988_34489" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                        width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_1988_34489)">
                        <path
                          d="M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20H6ZM12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16Z"
                          fill="#1C1B1F" />
                      </g>
                    </svg>
                  </button>
                  <mat-menu #menu="matMenu" [overlapTrigger]="false">
                    <!-- <button mat-menu-item (click)="runNano(item)">Nano</button> -->
                    <button mat-menu-item 
                      (click)="runFolder(item.id, item, TF.FALSE)"
                      [disabled]="hasFilesRequiringGoodsAndMaterialProcessing(item)"
                      [matTooltip]="hasFilesRequiringGoodsAndMaterialProcessing(item) ? 'TXT/XLSX files require Goods and Material processing' : ''"
                      [class.disabled-menu-item]="hasFilesRequiringGoodsAndMaterialProcessing(item)">
                      Regular
                    </button>
                    <button mat-menu-item (click)="runFolder(item.id, item, TF.TRUE)">
                      Goods and Material
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="setFolderPassword($event, item)">
                      <mat-icon>{{ item.isPasswordProtected ? 'lock' : 'lock_open' }}</mat-icon>
                      {{ item.isPasswordProtected ? 'Manage password' : 'Set password' }}
                    </button>
                  </mat-menu>
                  <button *ngIf="!isProcessingSubfolder(getStatus(item)) && item.type == 'folder'" mat-button
                    class="right-side-folder-button" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                    (menuOpened)="toggleDropdown(i, true)" (menuClosed)="toggleDropdown(i, false)" [disabled]="
                      item.invoices?.items?.length === 0 ||
                      isProcessingSubfolder(getStatus(item)) ||
                      checkLengthOfInvoicesObj(item)
                    " [class.disabled-run-button]="
                      item.invoices?.items?.length === 0 ||
                      isProcessingSubfolder(getStatus(item)) ||
                      checkLengthOfInvoicesObj(item)
                    ">
                    {{ "run" | translate }}
                  </button>
                  <button *ngIf="isProcessingSubfolder(getStatus(item))" mat-button
                    class="right-side-folder-button red-button" (click)="
                      $event.stopPropagation(); stopScanning(item.id, item)
                    ">
                    Stop scanning
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <!-- End of subfolders -->
  </div>


  <div style="height: 100%">
    <div class="invoices-wrapper scrollable-container" #scrollableContainer (scroll)="onScroll($event)"
      [class.has-selected]="selectedInvoicesNum > 0" [class.has-dragged]="isDraggedOver"
      accept="image/png, image/gif, image/jpeg, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
      <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: auto;
          margin-right: auto;
        " *ngIf="isDraggedOver">
        <img height="90" width="80" src="/assets/icons/folderIcon.svg" class="img-fluid" style="margin-right: 16px" />

        <div *ngIf="isDraggedOver" style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          ">
          <div class="dragInTo">Drag in to</div>
          <div class="folderName">"{{ folderName }}"</div>
        </div>
      </div>

      <div class="add-new-invoice-wrapper">
        <div class="invoice-name-wrapper invisible-placeholder"></div>
        <div class="add-new-invoice" (click)="selectedInvoicesNum === 0 ? imageInput.click() : null"
          *ngIf="!isDraggedOver && !isDownloadInProgress && !uploading"
          [style.cursor]="selectedInvoicesNum > 0 ? 'not-allowed' : 'pointer'">
          <mat-icon class="new-invoice-icon"
            [style.color]="selectedInvoicesNum > 0 ? '#CCCCCC' : '#27272c'">add</mat-icon>
          <div class="small-text">
            <span class="upload-image-text" [style.color]="selectedInvoicesNum > 0 ? '#CCC' : '#27272c'">{{
              "uploadImage" | translate }}</span>
            <span class="limit-mb" [style.color]="selectedInvoicesNum > 0 ? '#CCC' : '#27272c'">(Click or Drag and
              Drop)</span>
            <span class="limit-mb" [style.color]="selectedInvoicesNum > 0 ? '#CCC' : '#797a81'">max 5mb</span>
            <input class="hidden" type="file" id="upload-file" #imageInput name="upload-file"
              accept="image/png, image/gif, image/jpeg, application/pdf, text/plain, .txt, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx, .xls" ngf-max-size="2MB" (change)="addPhoto($event)"
              (click)="imageInput.value = ''" multiple />
          </div>
        </div>
        <div class="invoice-created-at invisible-placeholder"></div>
      </div>

      <ng-container *ngIf="
          !isLoading && !uploading && !isDraggedOver && !isDownloadInProgress
        ">
        <div class="invoice-wrapper" *ngFor="let invoice of filteredInvoicesList">
          <div class="invoice-name-wrapper" matTooltip="{{ invoice.title }}" matTooltipPosition="above">
            <mat-form-field *ngIf="invoice.isEditing; else displayInvoiceTitle" class="invoice-name-field"
              [hideRequiredMarker]="true">
              <input type="text" class="invoice-name-editable" matInput [(ngModel)]="invoice.title"
                [style.width.px]="195" (keydown.enter)="saveInvoiceName(invoice)" (click)="$event.stopPropagation()"
                (blur)="cancelInvoiceEditing(invoice)" />
              <img src="assets/icons/check-doc.svg" class="edit-icon"
                (click)="saveInvoiceName(invoice); $event.stopPropagation()" (mousedown)="$event.preventDefault()" />

              <img src="assets/icons/close-doc.svg" (click)="
                  $event.stopPropagation(); cancelInvoiceEditing(invoice)
                " class="edit-icon" />
            </mat-form-field>

            <ng-template #displayInvoiceTitle>
              <div class="invoice-name-container">
                <span class="invoice-name-text">{{ invoice.title }}</span>
                <img src="assets/icons/edit-doc.svg" class="edit-icon always-visible" (click)="
                    startEditingInvoice(invoice); $event.stopPropagation()
                  " />
              </div>
            </ng-template>
          </div>
          <div class="invoice" [class.selected]="invoice.selected" [class.dragging]="isDraggingInvoice"
            (click)="openImageInNewTab(invoice)" draggable="true" (dragstart)="onInvoiceDragStarted(invoice, $event)"
            (dragend)="onInvoiceDragEnded()">
            <div class="ops-wrapper" *ngIf="!(isProcessing() && areWeinRunningProccess)"
              (click)="$event.stopPropagation()">
              <div>
                <mat-checkbox [checked]="invoice.selected" (change)="toggleCheckbox(invoice)"
                  [style.margin-top.px]="selectedInvoicesNum > 0 ? 2.7 : 0" style="margin-left: 4px"></mat-checkbox>
              </div>
              <div class="trash">
                <div class="icon-wrapper1" (click)="downloadInvoice(invoice, $event)" (mouseover)="invoice.downloadHovered = true"
                  (mouseleave)="invoice.downloadHovered = false" [hidden]="selectedInvoicesNum > 0"
                  matTooltip="Download" matTooltipPosition="above">
                  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    [style.fill]="invoice.downloadHovered ? '#1E31CF' : '#27272C'">
                    <path d="M9 14L4 9L5.4 7.55L8 10.15V0H10V10.15L12.6 7.55L14 9L9 14ZM2 20C1.45 20 0.979333 19.8043 0.588 19.413C0.196 19.021 0 18.55 0 18V15H2V18H16V15H18V18C18 18.55 17.8043 19.021 17.413 19.413C17.021 19.8043 16.55 20 16 20H2Z" />
                  </svg>
                </div>
                <div class="icon-wrapper1" (click)="deleteInvoice(invoice, $event)" (mouseover)="invoice.hovered = true"
                  (mouseleave)="invoice.hovered = false" [hidden]="selectedInvoicesNum > 0">
                  <svg (click)="deleteInvoice(invoice, $event)" class="trash-icon-button" width="18" height="20"
                    viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-container"
                    [style.fill]="invoice.hovered ? '#1E31CF' : '#27272C'">
                    <path
                      d="M3.58325 19.75C2.98742 19.75 2.47753 19.538 2.05359 19.1141C1.62892 18.6894 1.41659 18.1792 1.41659 17.5833V3.5H0.333252V1.33333H5.74992V0.25H12.2499V1.33333H17.6666V3.5H16.5833V17.5833C16.5833 18.1792 16.3713 18.6894 15.9473 19.1141C15.5227 19.538 15.0124 19.75 14.4166 19.75H3.58325ZM14.4166 3.5H3.58325V17.5833H14.4166V3.5ZM5.74992 15.4167H7.91659V5.66667H5.74992V15.4167ZM10.0833 15.4167H12.2499V5.66667H10.0833V15.4167Z" />
                  </svg>
                </div>
              </div>
            </div>

            <img *ngIf="!invoice.thumbnailPath" src="{{
                invoice.name.endsWith('.pdf') || invoice.name.toLowerCase().endsWith('.xlsx') || invoice.name.toLowerCase().endsWith('.xls')
                  ? localImages.fileDocument
                  : invoice.name.endsWith('.txt')
                    ? localImages.textFileDocument
                    : invoice.name
              }}" alt="Invoice" class="invoice-preview" />
            <img *ngIf="invoice.thumbnailPath" src="{{ invoice.thumbnailPath }}" alt="Invoice"
              class="invoice-preview" />
            <app-email-avatar *ngIf="invoice.invoiceUserAssignments?.items?.length"
              [assignments]="invoice.invoiceUserAssignments"></app-email-avatar>
          </div>

          <div class="invoice-created-at">
            {{ invoice.createdAt | date : "MMM d, y, HH:mm" }}
          </div>
        </div>
      </ng-container>
      <!-- <ng-container *ngIf="isLoading || uploading || isDownloadInProgress">
        <div
          class="invoice custom-border"
          *ngFor="let invoice of [1, 2, 3, 4, 5, 6, 7, 8]"
        >
          <ngx-skeleton-loader
            count="1"
            appearance="circle"
            [theme]="{
              height: '100%',
              width: '100%',
              'border-radius': '0px',
              margin: '0px'
            }"
          >
          </ngx-skeleton-loader>
        </div>
      </ng-container> -->
    </div>
  </div>
</div>